<label class="title" for="cloud-subject-select">
  {{ 'pipeline_step_editor.subject.title' | translate }}
</label>
<p class="description">
  {{ 'pipeline_step_editor.subject.description' | translate }}
</p>
<select
  id="cloud-subject-select"
  class="ts-selector"
  [disabled]="disabled"
  (change)="onChange($event)"
>
  <option [value]="SAMPLE" [selected]="value === SAMPLE">
    {{ 'pipeline_step_editor.subject.option_sample' | translate }}
  </option>
  <option [value]="ASSET" [selected]="value === ASSET">
    {{ 'pipeline_step_editor.subject.option_asset' | translate }}
  </option>
</select>
